import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * The element's top edge in the viewport, kept current through page scroll, resize and layout
 * changes above it (a system banner appearing). Undefined until the element is measured.
 */
export const useViewportTop = element => {
  const $ = _c(3);
  const [top, setTop] = useState();
  let t0;
  let t1;
  if ($[0] !== element) {
    t0 = () => {
      if (!element) {
        return;
      }
      const measure = () => setTop(element.getBoundingClientRect().top);
      measure();
      window.addEventListener("scroll", measure, {
        passive: true
      });
      window.addEventListener("resize", measure);
      const observer = new ResizeObserver(measure);
      observer.observe(document.body);
      return () => {
        window.removeEventListener("scroll", measure);
        window.removeEventListener("resize", measure);
        observer.disconnect();
      };
    };
    t1 = [element];
    $[0] = element;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return top;
};